import axios from 'axios'

export default {
  state: {
    permissions: {},
    user: {},
    AUTH_ERROR: false,
    isAuthenticated: false
  },
  actions: {
    authorize (context, credentials) {
      return axios
        .post('gate/api/v1/accounts/login/', credentials)
        .then(values => {
          context.commit('getUser', values)
          return new Promise(resolve => resolve(true))
        })
        .catch(error => {
          context.commit('SET_AUTH_ERROR')
          return new Promise((resolve, reject) => reject(error))
        })
    },
    authorizeToken (context, credentials) {
      return axios
        .post('gate/api/v1/accounts/verify-token/', credentials)
        .then(values => {
          context.commit('getUser', values)
          return new Promise(resolve => resolve(true))
        })
        .catch(error => {
          context.commit('SET_AUTH_ERROR')
          return new Promise((resolve, reject) => reject(error))
        })
    },
    deauthorize (context) {
      context.commit('Exit')
    }
  },
  mutations: {
    getUser (state, values) {
      localStorage.setItem('Token', values.data.token)
      state.permissions = values.data.permissions
      state.user = values.data.user
      state.isAuthenticated = true
    },
    SET_AUTH_ERROR (state) {
      state.AUTH_ERROR = true
    },
    Exit (state) {
      localStorage.removeItem('Token')
      state.permissions = {}
      state.user = {}
      state.isAuthenticated = false
      state.AUTH_ERROR = false
    }
  },
  getters: {
    getUser (state) {
      return state.user
    },
    isAuthenticated (state) {
      return state.isAuthenticated
    }
  }
}
